<div class="wl-simple-html-editor" [ngClass]="styleClass">
  <p-editor
    #primeEditor
    [(ngModel)]="value"
    [readonly]="readonly"
    [style]="style"
    [styleClass]="styleClass"
    placeholder="placeholder"
    [formats]="formats"
    [modules]="modules"
    [bounds]="bounds"
    [scrollingContainer]="scrollingContainer"
    [debug]="debug"
    (onInit)="onEditorInitHandler($event)"
    (onTextChange)="onTextChangeHandler($event)"
    (onSelectionChange)="onSelectionChangeHandler($event)">
  </p-editor>
</div>
